:host{position:relative}.grid-actions{display:flex;align-items:center;gap:8px}
/*# sourceMappingURL=grid-table-ng.component-M3EVDXFF.css.map */
